import { observable } from 'mobx';
import axios from 'axios';
import { Modal } from 'antd';
const Confirm = Modal.confirm;

export class StratCenter {
    @observable strategy = null;
    @observable liked = {};

    constructor({ rootStore }) {
        this.rootStore = rootStore;
    }

    async create(listing) {
        return await axios.post(`${this.rootStore.env.stratCenterApi}create`, listing, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async update(id, listing) {
        return await axios.post(`${this.rootStore.env.stratCenterApi}${id}/edit`, listing, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async clone(id, version, isNewType) {
        if (isNewType) {
            return await axios.post(
                `${this.rootStore.env.stratCenterApi}${id}/clone`,
                { version, update: false },
                {
                    headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
                }
            );
        }

        Confirm({
            title: 'Update existing strategies?',
            content: 'This will overwrite any custom modifications',
            okText: 'Yes',
            okType: 'primary',
            cancelText: 'No',
            onOk: async () => {
                return await axios.post(
                    `${this.rootStore.env.stratCenterApi}${id}/clone`,
                    { version, update: true },
                    {
                        headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
                    }
                );
            },
            onCancel: async () => {
                return await axios.post(
                    `${this.rootStore.env.stratCenterApi}${id}/clone`,
                    { version, update: false },
                    {
                        headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
                    }
                );
            }
        });
    }

    async search(query) {
        return await axios.post(`${this.rootStore.env.stratCenterApi}search`, query, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async getUserListings() {
        return await axios.get(`${this.rootStore.env.stratCenterApi}user_listings`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async getUserListing(id) {
        return await axios.get(`${this.rootStore.env.stratCenterApi}${id}/edit`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async delete(id) {
        return await axios.post(
            `${this.rootStore.env.stratCenterApi}${id}/delete`,
            {},
            {
                headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
            }
        );
    }

    async recent() {
        return await axios.get(`${this.rootStore.env.stratCenterApi}recent`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async popular() {
        return await axios.get(`${this.rootStore.env.stratCenterApi}popular`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }

    async getListing(id) {
        return await axios.get(`${this.rootStore.env.stratCenterApi}${id}`, {
            headers: { Authorization: `Bearer ${this.rootStore.userStore.idToken}` }
        });
    }
}



// WEBPACK FOOTER //
// ./src/stores/StratCenter.js